<script>
export default {
    page() {
        const title = 'Account Management'
        const description = 'Account Management'
        return {
            title,
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },

                { property: 'twitter:title', vmid: 'twitter:title', content: title },
                { property: 'twitter:description', vmid: 'twitter:description', content: description },
            ],
        }
    },
}
</script>

<script setup>
import BoxedLayout from '@layouts/boxed'
import Logo from '@components/logo'
</script>

<template>
    <BoxedLayout>
        <Logo/>
        <router-view class="router-content"/>
    </BoxedLayout>

</template>

<style lang="scss" scoped>
@import '@design';

.router-content {
    margin-top: $s-xl;
}

@include tablet {
    .router-content {
        margin-top: $s-xxl;
    }
}

@include desktop {
    .router-content {
        margin-top: $s-h;
    }
}
</style>
